import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';

import { changeLocation } from 'actions/map';
import * as MapPropTypes from 'fera-prop-types/map';

export class AccessibleMapMenu extends Component {
  handleClick = async (areaId) => {
    const { currentArea, dispatch, isMoving } = this.props;
    if (areaId === currentArea.id) {
      return;
    }
    if (isMoving) {
      return;
    }
    await dispatch(changeLocation(areaId));
  };

  render = () => {
    const { areas, canTravel } = this.props;
    if (!canTravel) {
      return <div>Travel is currently unavailable.</div>;
    }
    return (
      <ul className="accessible-map-menu">
        {areas
          .filter(a => !!a.id && !!a.name && a.unlocked)
          .map(area => (
          <li key={area.areaKey}>
            <button
              disabled={!area.unlocked}
              onClick={() => this.handleClick(area.id)}
              type="button"
            >
              {area.name}
            </button>
          </li>
        ))}
      </ul>
    );
  }
}

AccessibleMapMenu.displayName = 'AccessibleMapMenu';

AccessibleMapMenu.propTypes = {
  areas: PropTypes.arrayOf(MapPropTypes.Area).isRequired,
  canTravel: PropTypes.bool.isRequired,
  currentArea: MapPropTypes.Area.isRequired,
  dispatch: PropTypes.func.isRequired,
  isMoving: PropTypes.bool.isRequired,
};

const mapStateToProps = ({
  map: {
    areas,
    canTravel,
    currentArea,
    isMoving,
  },
}) => ({
  areas,
  canTravel,
  currentArea,
  isMoving,
});

export default connect(mapStateToProps)(AccessibleMapMenu);
